export default function isNotEmpty(string: string | undefined): boolean {
  return typeof string !== 'undefined' && typeof string === 'string' && string.length > 0
}
